import { useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { FiShoppingCart, FiSearch, FiX } from 'react-icons/fi';
import { motion } from 'framer-motion';
import Logo from "../assets/Cmp_logo10.jpg";
import LocationIcon from "../assets/Location.png";
import PhoneIcon from "../assets/phone-call.png";
import WhatsappIcon from "../assets/whatsapp.png";
import UserIcon from "../assets/user.png";
import axios from 'axios';
import { jsPDF } from "jspdf";
import localforage from 'localforage';
import Header from './HeaderLayouts';
import Footer from './FooterLayouts';
import quick_image from '../assets/quick_image.jpg';
import API_BASE_URL from "./apiConfig";

function QuickPurchase() {
  const navigate = useNavigate();
  const [productCategories, setProductCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  const [cartItems, setCartItems] = useState({});
  const mobileMediaQuery = window.matchMedia('(max-width: 768px)');
  const [isSubmitting, setIsSubmitting] = useState(false);

  //viewcart 
  const viewCartRef = React.useRef(null);
  const [showViewCart, setShowViewCart] = useState(false);
  const location = useLocation();
  const [cartProducts, setCartProducts] = useState([]);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const formRef = React.useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [error, setError] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);
  const [orderId, setOrderId] = useState("");
  const [finalAmountToPay, setFinalAmountToPay] = useState(0);
  const [amountBelowMinimum, setAmountBelowMinimum] = useState(false);
  const [showRemoveConfirm, setShowRemoveConfirm] = useState(false);
  const [productToRemove, setProductToRemove] = useState(null);
  const [previousQuantity, setPreviousQuantity] = useState(1);
  const [isProcessing, setIsProcessing] = useState(false);
  // Log received cart items and send to API
  useEffect(() => {
    console.log('Received in ViewCart:', location.state?.cartItems);

    if (location.state?.cartItems) {


    }
  }, [location.state]);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const initialProducts = [

  ];

  const handleProceedClick = () => {
    if (subTotal < 3000) return;

    // Ensure cartProducts is synced before proceeding
    const currentCart = JSON.parse(localStorage.getItem('cart')) || {};
    if (Object.keys(currentCart).length > 0) {
      // Optional: validate prices via API later
      // sendCartItemsToAPI(currentCart);
    }
    setShowDetailsForm(true);

    // Smooth scroll to form
    setTimeout(() => {
      const formElement = document.getElementById('orderDetailsForm');
      if (formElement) {
        const headerHeight = document.querySelector('header')?.offsetHeight || 0;
        const offsetPosition =
          formElement.getBoundingClientRect().top +
          window.pageYOffset -
          headerHeight -
          20;
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      }
    }, 100);
  };









  // Handle quantity update
  const updateQuantity = (productId, newQuantity, prevQuantity) => {
    // Handle empty quantity field - just clear the field but keep product in cart
    if (newQuantity === "") {
      setCartProducts(prevProducts =>
        prevProducts.map(product =>
          product.id === productId
            ? {
              ...product,
              quantity: "",
              subtotal: 0
            }
            : product
        )
      );
      // Also update cartItems (localStorage)
      setCartItems(prev => ({
        ...prev,
        [productId]: {
          ...prev[productId],
          quantity: ""
        }
      }));
      // Update productCategories to keep in sync
      setProductCategories(prevCategories =>
        prevCategories.map(category => ({
          ...category,
          products: category.products.map(p =>
            p.id === productId ? { ...p, quantity: "" } : p
          )
        }))
      );
      return;
    }

    const quantityNum = parseInt(newQuantity, 10);

    // If invalid number, revert to previous quantity
    if (isNaN(quantityNum)) {
      setCartProducts(prevProducts =>
        prevProducts.map(product =>
          product.id === productId
            ? { ...product, quantity: prevQuantity, subtotal: product.price * prevQuantity }
            : product
        )
      );
      return;
    }

    // If quantity is 0, show confirmation popup
    if (quantityNum === 0) {
      const product = cartProducts.find(p => p.id === productId);
      setProductToRemove(product);
      setPreviousQuantity(prevQuantity);
      setShowRemoveConfirm(true);
      return;
    }

    // Minimum quantity is 1
    if (quantityNum < 1) {
      setCartProducts(prevProducts =>
        prevProducts.map(product =>
          product.id === productId
            ? {
              ...product,
              quantity: 1,
              subtotal: product.price * 1
            }
            : product
        )
      );
      // Also update cartItems
      setCartItems(prev => ({
        ...prev,
        [productId]: {
          ...prev[productId],
          quantity: 1
        }
      }));
      // Sync productCategories
      setProductCategories(prevCategories =>
        prevCategories.map(category => ({
          ...category,
          products: category.products.map(p =>
            p.id === productId ? { ...p, quantity: 1 } : p
          )
        }))
      );
      return;
    }

    // Normal quantity update
    setCartProducts(prevProducts =>
      prevProducts.map(product =>
        product.id === productId
          ? {
            ...product,
            quantity: quantityNum,
            subtotal: product.price * quantityNum
          }
          : product
      )
    );

    // Update cartItems (localStorage)
    setCartItems(prev => ({
      ...prev,
      [productId]: {
        ...prev[productId],
        quantity: quantityNum
      }
    }));

    // Sync productCategories
    setProductCategories(prevCategories =>
      prevCategories.map(category => ({
        ...category,
        products: category.products.map(p =>
          p.id === productId ? { ...p, quantity: quantityNum } : p
        )
      }))
    );
  };


  // State for form inputs
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    contactNumber: '',           // Maps to PhoneNumber
    whatsappNumber: '',          // Maps to AltPhoneNumber
    sameAsContact: false,
    address: '',                 // Maps to Street
    city: '',
    district: '',                // If not present, use city or add field
    state: '',
    pinCode: '',
    email: '',
    totalPayAmount: 0,           // From cart total
    orderId: '',                 // Set earlier
  });


  // State for collapsible sections
  const [openSections, setOpenSections] = useState({
    personal: true,
    address: false,
    bank: false,
  });

  // Toggle section function
  const toggleSection = (section) => {
    setOpenSections({
      personal: section === 'personal',
      address: section === 'address',
      bank: section === 'bank',
    });
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => {
      let updatedData = { ...prevData };

      if (type === 'checkbox') {
        updatedData[name] = checked;

        if (name === 'sameAsContact' && checked) {
          updatedData.whatsappNumber = prevData.contactNumber;
        }
      } else {
        if (name === 'contactNumber' || name === 'whatsappNumber' || name === 'pinCode') {
          const numericValue = value.replace(/[^0-9]/g, '').slice(0, 10);
          updatedData[name] = numericValue;

          if (name === 'contactNumber' && prevData.sameAsContact) {
            updatedData.whatsappNumber = numericValue;
          }
        } else if (name === 'accountNumber') {
          const numericValue = value.replace(/[^0-9]/g, '').slice(0, 18);
          updatedData[name] = numericValue;
        } else if (name === 'ifscCode') {
          const alphanumericValue = value.replace(/[^A-Za-z0-9]/g, '').slice(0, 11).toUpperCase();
          updatedData[name] = alphanumericValue;
        } else {
          updatedData[name] = value;
        }
      }

      return updatedData;
    });
  };


  // Calculate totals
  const calculateTotals = () => {
    let netTotal = 0,
      discountTotal = 0,
      subTotal = 0;
    cartProducts.forEach((p) => {
      netTotal += p.originalPrice * p.quantity;
      discountTotal += (p.originalPrice * p.quantity) - p.subtotal;
      subTotal += p.subtotal;
    });
    return { netTotal, discountTotal, subTotal };
  };

  const { netTotal, discountTotal, subTotal } = calculateTotals();




  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsProcessing(true);

    // Validation
    if (
      !formData.firstName ||
      !formData.contactNumber ||
      !formData.address ||
      !formData.pinCode ||
      !formData.city ||
      !formData.district ||
      !formData.state
    ) {
      alert("Please fill all required fields.");
      setIsProcessing(false);
      return;
    }

    const termsCheckbox = document.getElementById('agreeToTerms');
    if (!termsCheckbox.checked) {
      alert("Please check the Terms and Conditions before confirming your order.");
      setIsProcessing(false);
      return;
    }

    try {
      // --- LOCAL UI TEST MODE ---
      // Set this to true to bypass backend APIs and just generate the bill locally.
      let orderId = "";
      let response;

        // 1. Confirm order → get orderId
        const productsPayload = cartProducts.map((item) => ({
          id: item.id,
          qty: item.quantity,
        }));

        const payload = {
          CompanyId: 1,
          FirstName: formData.firstName,
          LastName: formData.lastName || "",
          PhoneNumber: formData.contactNumber,
          AltPhoneNumber: formData.whatsappNumber || formData.contactNumber,
          Street: formData.address,
          City: formData.city,
          District: formData.district || formData.city,
          State: formData.state,
          PINCode: formData.pinCode,
          EmailID: formData.email || "",
          Products: productsPayload,
        };

        const confirmResponse = await axios.post(
          `${API_BASE_URL}api/Crackers/ConfirmOrder`,
          payload,
          { headers: { "Content-Type": "application/json" } }
        );
        response = confirmResponse;

        if (response.data?.statusCode !== 200) {
          throw new Error(response.data?.statusDesc || "Order confirmation failed");
        }

        orderId = response.data.orderId || response.data.data?.orderId;
        if (!orderId) {
          alert("Order confirmed but no Order ID received. Please contact support.");
          setIsProcessing(false);
          return;
        }

      setOrderId(orderId);

      // 2. Generate PDF
      const pdfBlob = await generateOrderPDF(orderId); // This also saves & opens PDF

        // 3. Upload PDF to server
        const formDataToSend = new FormData();
        formDataToSend.append("OrderId", orderId);
        formDataToSend.append("Document", pdfBlob, `Order_${orderId}.pdf`);
        formDataToSend.append("CompanyId", 1);

        const docResponse = await axios.post(
          `${API_BASE_URL}api/Crackers/SendorderedDoc`,
          formDataToSend,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        let documentUrl = "";
        if (docResponse.data?.statusCode === 200) {
          documentUrl = docResponse.data.data?.documentUrl || "";
        }

        // 4. Send WhatsApp alert to ADMIN
        const cusName = `${formData.firstName} ${formData.lastName}`.trim() || formData.firstName;
        const newOrderPayload = {
          CompanyName: "SRI GOKILAA CRACKERS",
          To: "919787009888", // Ensure this is correct
          CusName: cusName,
          MobileNumber: formData.contactNumber,
          OrderNumber: orderId,
          DispatchAmount: subTotal.toFixed(2),
          text: "ORDER CONFIRMATION - SRI GOKILAA CRACKERS",
          pdfUrl: documentUrl,
        };

        try {
          const adminResponse = await axios.post(
            `${API_BASE_URL}api/Whatsapp/NewOrder`,
            newOrderPayload,
            { headers: { 'Content-Type': 'application/json' } }
          );
          if (adminResponse.data?.statusCode === 200) {
            console.log("✅ Admin WhatsApp alert sent");
          } else {
            console.warn("⚠️ Admin WhatsApp API non-200:", adminResponse.data);
          }
        } catch (whatsappError) {
          console.error("❌ Failed to send WhatsApp to admin:", whatsappError);
          // Do NOT fail the order — just log
        }

        // 5. (Optional) Send PDF to CUSTOMER via WhatsApp
        if (documentUrl) {
          try {
            await axios.post(
              `${API_BASE_URL}`,
              {
                to: formData.whatsappNumber || formData.contactNumber,
                type: "document",
                document: {
                  link: documentUrl,
                  filename: `Order_${orderId}.pdf`,
                  caption: `Thank you! Your order ${orderId} is confirmed.`
                }
              },
              { headers: { "Content-Type": "application/json" } }
            );
            console.log("✅ Customer WhatsApp PDF sent");
          } catch (customerError) {
            console.error("⚠️ Failed to send PDF to customer:", customerError);
          }
        }

        // 6. Reset UI & state
        setFormData({
          firstName: "", lastName: "", contactNumber: "", whatsappNumber: "",
          sameAsContact: false, address: "", city: "", district: "", state: "",
          pinCode: "", email: "", totalPayAmount: 0, orderId: ""
        });
        setCartProducts([]);
        setCartItems({});
        setProductCategories(prev =>
          prev.map(cat => ({
            ...cat,
            products: cat.products.map(p => ({ ...p, quantity: "" }))
          }))
        );
        localStorage.removeItem('cart');
        setShowViewCart(false);
        setShowDetailsForm(false);
        setOpenSections({ personal: true, address: false, bank: false });

        const finalMessage = response?.data?.message || "Order confirmed!";
        alert(`✅ Success!\n${finalMessage}`);
        window.scrollTo({ top: 0, behavior: "smooth" });

      } catch (error) {
        const errorMsg =
          error.response?.data?.message ||
          error.response?.data?.statusDesc ||
          error.message ||
          "Failed to submit order. Please check your internet connection.";
        console.error("Order submission error:", errorMsg, error);
        alert(`❌ Order failed: ${errorMsg}`);
      } finally {
        setIsProcessing(false);
      }
    };

    useEffect(() => {
      setAmountBelowMinimum(subTotal < 3000);
    }, [subTotal]);

    /* GARBAGE START
    
      // Validation
      if (
        !formData.firstName ||
        !formData.contactNumber ||
        !formData.address ||
        !formData.pinCode ||
        !formData.city ||
        !formData.district ||
        !formData.state
      ) {
        alert("Please fill all required fields.");
        setIsProcessing(false);
        return;
      }
    
      const termsCheckbox = document.getElementById('agreeToTerms');
      if (!termsCheckbox.checked) {
        alert("Please check the Terms and Conditions before confirming your order.");
        setIsProcessing(false);
        return;
      }
    
      try {
        // --- LOCAL UI TEST MODE ---
        // Set this to true to bypass backend APIs and just generate the bill locally.
        const isLocalTest = true; 
        let orderId = "";
        let response;
    
        if (!isLocalTest) {
          // 1. Confirm order → get orderId
          const productsPayload = cartProducts.map((item) => ({
            id: item.id,
            qty: item.quantity,
          }));
    
          const payload = {
            CompanyId: 1,
            FirstName: formData.firstName,
            LastName: formData.lastName || "",
            PhoneNumber: formData.contactNumber,
            AltPhoneNumber: formData.whatsappNumber || formData.contactNumber,
            Street: formData.address,
            City: formData.city,
            District: formData.district || formData.city,
            State: formData.state,
            PINCode: formData.pinCode,
            EmailID: formData.email || "",
            Products: productsPayload,
          };
    
          response = await axios.post(
            `${API_BASE_URL}api/Crackers/ConfirmOrder`,
            payload,
            { headers: { "Content-Type": "application/json" } }
          );
    
          if (response.data?.statusCode !== 200) {
            throw new Error(response.data?.statusDesc || "Order confirmation failed");
          }
    
          orderId = response.data.orderId || response.data.data?.orderId;
          if (!orderId) {
            alert("Order confirmed but no Order ID received. Please contact support.");
            setIsProcessing(false);
            return;
          }
        } else {
          // Mock order ID for local testing
          orderId = "TEST-ORDER-" + Math.floor(Math.random() * 10000);
        }
    
        setOrderId(orderId);
    
        // 2. Generate PDF
        const pdfBlob = await generateOrderPDF(orderId); // This also saves & opens PDF
    
        if (!isLocalTest) {
          // 3. Upload PDF to server
          const formDataToSend = new FormData();
          formDataToSend.append("OrderId", orderId);
          formDataToSend.append("Document", pdfBlob, `Order_${orderId}.pdf`);
          formDataToSend.append("CompanyId", 1);
    
          const docResponse = await axios.post(
            `${API_BASE_URL}api/Crackers/SendorderedDoc`,
            formDataToSend,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
    
          let documentUrl = "";
          if (docResponse.data?.statusCode === 200) {
            documentUrl = docResponse.data.data?.documentUrl || "";
          }
    
          // 4. Send WhatsApp alert to ADMIN
          const cusName = `${formData.firstName} ${formData.lastName}`.trim() || formData.firstName;
          const newOrderPayload = {
            CompanyName: "SRI GOKILAA CRACKERS",
            To: "919787009888", // Ensure this is correct
            CusName: cusName,
            MobileNumber: formData.contactNumber,
            OrderNumber: orderId,
            DispatchAmount: subTotal.toFixed(2),
            text: "ORDER CONFIRMATION - SRI GOKILAA CRACKERS",
            pdfUrl: documentUrl,
          };
    
          try {
            const adminResponse = await axios.post(
              `${API_BASE_URL}api/Whatsapp/NewOrder`,
              newOrderPayload,
              { headers: { 'Content-Type': 'application/json' } }
            );
            if (adminResponse.data?.statusCode === 200) {
              console.log("✅ Admin WhatsApp alert sent");
            } else {
              console.warn("⚠️ Admin WhatsApp API non-200:", adminResponse.data);
            }
          } catch (whatsappError) {
            console.error("❌ Failed to send WhatsApp to admin:", whatsappError);
            // Do NOT fail the order — just log
          }
    
          // 5. (Optional) Send PDF to CUSTOMER via WhatsApp
          if (documentUrl) {
            try {
              await axios.post(
                `${API_BASE_URL}`,
                {
                  to: formData.whatsappNumber || formData.contactNumber,
                  type: "document",
                  document: {
                    link: documentUrl,
                    filename: `Order_${orderId}.pdf`,
                    caption: `Thank you! Your order ${orderId} is confirmed.`
                  }
                },
                { headers: { "Content-Type": "application/json" } }
              );
              console.log("✅ Customer WhatsApp PDF sent");
            } catch (customerError) {
              console.error("⚠️ Failed to send PDF to customer:", customerError);
            }
          }
    
        // 6. Reset UI & state
        setFormData({
          firstName: "", lastName: "", contactNumber: "", whatsappNumber: "",
          sameAsContact: false, address: "", city: "", district: "", state: "",
          pinCode: "", email: "", totalPayAmount: 0, orderId: ""
        });
        setCartProducts([]);
        setCartItems({});
        setProductCategories(prev =>
          prev.map(cat => ({
            ...cat,
            products: cat.products.map(p => ({ ...p, quantity: "" }))
          }))
        );
        localStorage.removeItem('cart');
        setShowViewCart(false);
        setShowDetailsForm(false);
        setOpenSections({ personal: true, address: false, bank: false });
    
        const finalMessage = response?.data?.message || "Order confirmed!";
        alert(`✅ Success!\n${finalMessage}`);
        window.scrollTo({ top: 0, behavior: "smooth" });
    
      } catch (error) {
        const errorMsg =
          error.response?.data?.message ||
          error.response?.data?.statusDesc ||
          error.message ||
          "Failed to submit order. Please check your internet connection.";
        console.error("Order submission error:", errorMsg, error);
        alert(`❌ Order failed: ${errorMsg}`);
      } finally {
        setIsProcessing(false);
      }
    };
    
    /*
    discountTotal += (p.originalPrice * p.quantity) - p.subtotal;
         subTotal += p.subtotal;
       });
       return { netTotal, discountTotal, subTotal };
     };
    
     const { netTotal, discountTotal, subTotal } = calculateTotals();
    
    
     
    
    const handleSubmit = async (e) => {
      e.preventDefault();
      setIsProcessing(true);
    
      // Validation
      if (
        !formData.firstName ||
        !formData.contactNumber ||
        !formData.address ||
        !formData.pinCode ||
        !formData.city ||
        !formData.district ||
        !formData.state
      ) {
        alert("Please fill all required fields.");
        setIsProcessing(false);
        return;
      }
    
      const termsCheckbox = document.getElementById('agreeToTerms');
      if (!termsCheckbox.checked) {
        alert("Please check the Terms and Conditions before confirming your order.");
        setIsProcessing(false);
        return;
      }
    
      try {
        // --- LOCAL UI TEST MODE ---
        // Set this to true to bypass backend APIs and just generate the bill locally.
        const isLocalTest = true; 
        let orderId = "";
        let response;
    
        if (!isLocalTest) {
          // 1. Confirm order → get orderId
          const productsPayload = cartProducts.map((item) => ({
            id: item.id,
            qty: item.quantity,
          }));
    
          const payload = {
            CompanyId: 1,
            FirstName: formData.firstName,
            LastName: formData.lastName || "",
            PhoneNumber: formData.contactNumber,
            AltPhoneNumber: formData.whatsappNumber || formData.contactNumber,
            Street: formData.address,
            City: formData.city,
            District: formData.district || formData.city,
            State: formData.state,
            PINCode: formData.pinCode,
            EmailID: formData.email || "",
            Products: productsPayload,
          };
    
          response = await axios.post(
            `${API_BASE_URL}api/Crackers/ConfirmOrder`,
            payload,
            { headers: { "Content-Type": "application/json" } }
          );
    
          if (response.data?.statusCode !== 200) {
            throw new Error(response.data?.statusDesc || "Order confirmation failed");
          }
    
          orderId = response.data.orderId || response.data.data?.orderId;
          if (!orderId) {
            alert("Order confirmed but no Order ID received. Please contact support.");
            setIsProcessing(false);
            return;
          }
        } else {
          // Mock order ID for local testing
          orderId = "TEST-ORDER-" + Math.floor(Math.random() * 10000);
        }
    
        setOrderId(orderId);
    
        // 2. Generate PDF
        const pdfBlob = await generateOrderPDF(orderId); // This also saves & opens PDF
    
        if (!isLocalTest) {
          // 3. Upload PDF to server
          const formDataToSend = new FormData();
          formDataToSend.append("OrderId", orderId);
          formDataToSend.append("Document", pdfBlob, `Order_${orderId}.pdf`);
          formDataToSend.append("CompanyId", 1);
    
          const docResponse = await axios.post(
            `${API_BASE_URL}api/Crackers/SendorderedDoc`,
            formDataToSend,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
    
          let documentUrl = "";
          if (docResponse.data?.statusCode === 200) {
            documentUrl = docResponse.data.data?.documentUrl || "";
          }
    
          // 4. Send WhatsApp alert to ADMIN
          const cusName = `${formData.firstName} ${formData.lastName}`.trim() || formData.firstName;
          const newOrderPayload = {
            CompanyName: "SRI GOKILAA CRACKERS",
            To: "919787009888", // Ensure this is correct
            CusName: cusName,
            MobileNumber: formData.contactNumber,
            OrderNumber: orderId,
            DispatchAmount: subTotal.toFixed(2),
            text: "ORDER CONFIRMATION - SRI GOKILAA CRACKERS",
            pdfUrl: documentUrl,
          };
    
          try {
            const adminResponse = await axios.post(
              `${API_BASE_URL}api/Whatsapp/NewOrder`,
              newOrderPayload,
              { headers: { 'Content-Type': 'application/json' } }
            );
            if (adminResponse.data?.statusCode === 200) {
              console.log("✅ Admin WhatsApp alert sent");
            } else {
              console.warn("⚠️ Admin WhatsApp API non-200:", adminResponse.data);
            }
          } catch (whatsappError) {
            console.error("❌ Failed to send WhatsApp to admin:", whatsappError);
            // Do NOT fail the order — just log
          }
    
          // 5. (Optional) Send PDF to CUSTOMER via WhatsApp
          if (documentUrl) {
            try {
              await axios.post(
                `${API_BASE_URL}`,
                {
                  to: formData.whatsappNumber || formData.contactNumber,
                  type: "document",
                  document: {
                    link: documentUrl,
                    filename: `Order_${orderId}.pdf`,
                    caption: `Thank you! Your order ${orderId} is confirmed.`
                  }
                },
                { headers: { "Content-Type": "application/json" } }
              );
              console.log("✅ Customer WhatsApp PDF sent");
            } catch (customerError) {
              console.error("⚠️ Failed to send PDF to customer:", customerError);
            }
          }
    
        // 6. Reset UI & state
        setFormData({
          firstName: "", lastName: "", contactNumber: "", whatsappNumber: "",
          sameAsContact: false, address: "", city: "", district: "", state: "",
          pinCode: "", email: "", totalPayAmount: 0, orderId: ""
        });
        setCartProducts([]);
        setCartItems({});
        setProductCategories(prev =>
          prev.map(cat => ({
            ...cat,
            products: cat.products.map(p => ({ ...p, quantity: "" }))
          }))
        );
        localStorage.removeItem('cart');
        setShowViewCart(false);
        setShowDetailsForm(false);
        setOpenSections({ personal: true, address: false, bank: false });
    
        const finalMessage = response?.data?.message || "Order confirmed!";
        alert(`✅ Success!\n${finalMessage}`);
        window.scrollTo({ top: 0, behavior: "smooth" });
    
      } catch (error) {
        const errorMsg =
          error.response?.data?.message ||
          error.response?.data?.statusDesc ||
          error.message ||
          "Failed to submit order. Please check your internet connection.";
        console.error("Order submission error:", errorMsg, error);
        alert(`❌ Order failed: ${errorMsg}`);
      } finally {
        setIsProcessing(false);
      }
    };
    
    
    */
    const generateOrderPDF = (orderId) => {
      // === Input Validation ===
      if (!orderId) {
        console.error("Order ID is required");
        return null;
      }

      const doc = new jsPDF();
      const pageWidth = 210;
      const pageHeight = 297;
      const margin = 15;
      const contentWidth = pageWidth - 2 * margin;
      let currentPage = 1;
      let yPos = 33; // Start after header

      // --- Load Logo as Base64 (✅ Fix PNG Error) ---
      // Replace this with your actual base64 string

      // --- Header Function ---
      const addPageHeader = () => {
        // Safely get formData if it exists in scope, otherwise use fallback
        let uName = "";
        let uPhone = "";
        let uWhatsApp = "";
        let uAddress = "";

        if (typeof formData !== 'undefined' && formData) {
          uName = formData.firstName ? (formData.firstName + " " + (formData.lastName || "")).trim() : "";
          uPhone = formData.contactNumber || "";
          uWhatsApp = formData.whatsappNumber || formData.contactNumber || "";
          uAddress = formData.address ? (formData.address + (formData.city ? ", " + formData.city : "")) : "";
        }

        // White background
        doc.setFillColor(255, 255, 255);
        doc.rect(0, 0, pageWidth, pageHeight, 'F');

        // Header background Top
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        const hasSecondLine = doc.splitTextToSize(uAddress, 80)[1];
        const headerHeight = hasSecondLine ? 35 : 31.5;

        doc.setFillColor(11, 41, 115); // Dark blue
        doc.rect(0, 0, pageWidth, headerHeight, 'F');

        // Logo circle
        const logoWidth = 16;
        const logoHeight = 16;
        const logoCenterX = 18;
        const logoCenterY = 10.5;

        // Draw a white circle as background for the logo
        doc.setFillColor(255, 255, 255);
        doc.circle(logoCenterX, logoCenterY, 8.5, 'F');

        // Draw the logo image centered in the circle
        doc.addImage(Logo, "PNG", logoCenterX - logoWidth / 2, logoCenterY - logoHeight / 2, logoWidth, logoHeight);

        // Mask the corners of the square image with a thick stroke matching the background
        doc.setDrawColor(11, 41, 115); // Matches header background
        doc.setLineWidth(4);
        doc.circle(logoCenterX, logoCenterY, 9.5, 'S');

        // Company name
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(18);
        doc.setFont("helvetica", "bold");
        doc.text("Sri Gokilaa Crackers", pageWidth / 2, 9, { align: "center" });

        // Tagline replaced with phone numbers
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.text("+91 7016139368 | +91 9787009888", pageWidth / 2, 16, { align: "center" });

        // Status badge - Moved Right & Reduced Height
        doc.setFillColor(0, 184, 83); // Green button
        doc.roundedRect(145, 6.5, 55, 8, 1.5, 1.5, 'F'); // Slightly wider for orderId

        doc.setTextColor(255, 255, 255);
        doc.setFontSize(8);
        doc.setFont("helvetica", "bold");
        doc.text(orderId, 172.5, 11.5, { align: "center" });

        // Bottom Contact Bar background (Unified with header)
        // Handled by the single rect at the top

        // Horizontal separator
        doc.setDrawColor(50, 80, 160); // Subtle lighter blue
        doc.setLineWidth(0.3);
        doc.line(10, 20, pageWidth - 10, 20);

        // Contact Details
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");

        // Removed variables definition here, moved to top of addPageHeader

        // User Icon & Name
        doc.addImage(UserIcon, "PNG", 11, 25, 3.5, 3.5);
        const shortName = uName.length > 18 ? uName.substring(0, 16) + ".." : uName;
        doc.text(shortName, 16, 28);

        // Vertical Separator 1
        doc.setDrawColor(50, 80, 160);
        doc.line(50, 23, 50, 31);

        // Phone Icon & Number
        doc.addImage(PhoneIcon, "PNG", 53, 25, 3.5, 3.5);
        doc.text(uPhone, 58, 28);

        // Vertical Separator 2
        doc.setDrawColor(50, 80, 160);
        doc.setLineWidth(0.3);
        doc.line(82, 23, 82, 31);

        // WhatsApp Icon & Number
        doc.addImage(WhatsappIcon, "PNG", 86, 25, 3.5, 3.5);
        doc.setTextColor(255, 255, 255);
        doc.text(uWhatsApp, 91, 28);

        // Vertical Separator 3
        doc.setDrawColor(50, 80, 160);
        doc.line(114, 23, 114, 31);

        // Location Icon & Address
        doc.addImage(LocationIcon, "PNG", 118, 25, 3.5, 3.5);

        // Truncate and split address if too long
        doc.setTextColor(255, 255, 255);
        const shortAddress = doc.splitTextToSize(uAddress, 80)[0] || uAddress;

        // Adjust address Y to center it if it's one line or let it naturally span
        doc.text(shortAddress, 123, 28);

        // If address has more lines, add the second line
        const secondLine = doc.splitTextToSize(uAddress, 80)[1];
        if (secondLine) {
          doc.text(secondLine, 123, 32);
        }

        // Page number (only from page 2)
        if (currentPage > 1) {
          doc.setTextColor(100, 100, 100);
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");
          doc.text(`Page ${currentPage}`, pageWidth - 15, pageHeight - 10, { align: "right" });
        }
      };

      // --- Page Break Helper ---
      const checkPageBreak = (requiredHeight) => {
        if (yPos + requiredHeight > pageHeight - 15) {
          doc.addPage();
          currentPage++;
          addPageHeader();
          yPos = 33;
          return true;
        }
        return false;
      };

      // === Initialize First Page ===
      addPageHeader();

      // Spacing below header

      // === ORDER SUMMARY ===
      yPos += 2;
      // Estimate total height
      const tableHeaderHeight = 10;
      const rowHeight = 6;
      const numRows = cartProducts.length;
      const summaryHeight = 28; // Subtotal, Discount, Total
      const totalOrderHeight = tableHeaderHeight + (numRows * rowHeight) + summaryHeight;

      // Check if we need a new page before starting
      if (yPos + totalOrderHeight > pageHeight - 15) {
        if (yPos < pageHeight - 15) {
          // Use available space
        } else {
          doc.addPage();
          currentPage++;
          addPageHeader();
          yPos = 33;
        }
      }

      let tableCurrentY = yPos;
      let remainingProducts = [...cartProducts];
      let summaryAdded = false;
      let firstPage = true;
      let productIndex = 1;

      while (remainingProducts.length > 0 || !summaryAdded) {
        // Calculate how many rows can fit on current page
        const availableSpace = pageHeight - 15 - tableCurrentY;
        const headerOverhead = 20; // Title(10) + gaps(4) + colHeaders(6)
        
        let maxRowsThatFit = Math.floor((availableSpace - headerOverhead) / rowHeight);
        if (maxRowsThatFit < 0) maxRowsThatFit = 0;

        let rowsToDraw = Math.min(remainingProducts.length, maxRowsThatFit);
        let willDrawSummaryThisPage = false;
        
        if (rowsToDraw === remainingProducts.length && !summaryAdded) {
          if (availableSpace - headerOverhead - (rowsToDraw * rowHeight) >= summaryHeight) {
            willDrawSummaryThisPage = true;
          }
        }

        let rowsThatFit = rowsToDraw;

        // Ensure at least one row fits or we can draw the summary, else move to next page
        if (rowsThatFit <= 0 && !willDrawSummaryThisPage) {
          doc.addPage();
          currentPage++;
          addPageHeader();
          tableCurrentY = 33;
          firstPage = false;
          continue;
        }

        // Draw container for this page section
        const containerHeight = headerOverhead + (rowsThatFit * rowHeight) + (willDrawSummaryThisPage ? summaryHeight : 0);

        doc.setFillColor(248, 250, 252);
        doc.setDrawColor(226, 232, 240);
        doc.rect(margin, tableCurrentY, contentWidth, containerHeight, 'FD');

        // Draw header only on first page of table
        if (firstPage) {
          doc.setFillColor(30, 58, 138);
          doc.rect(margin, tableCurrentY, contentWidth, tableHeaderHeight, 'F');
          doc.setTextColor(255, 255, 255);
          doc.setFontSize(10);
          doc.setFont("helvetica", "bold");
          doc.text("ORDER SUMMARY", margin + 5, tableCurrentY + 6.5);

          // Add Order Date and Order No to the right end
          doc.setFontSize(8);
          doc.setFont("helvetica", "bold");
          doc.text(`Order Date: ${new Date().toLocaleDateString('en-GB')} | Order No-${orderId}`, pageWidth - margin - 5, tableCurrentY + 6.5, { align: "right" });
          tableCurrentY += tableHeaderHeight;

          // Add space between title and column headers on first page
          tableCurrentY += 4;
        } else {
          // Draw continuation header
          doc.setFillColor(30, 58, 138);
          doc.rect(margin, tableCurrentY, contentWidth, tableHeaderHeight, 'F');
          doc.setTextColor(255, 255, 255);
          doc.setFontSize(10);
          doc.setFont("helvetica", "bold");
          doc.text("ORDER SUMMARY (CONTINUED)", margin + 5, tableCurrentY + 6.5);
          tableCurrentY += tableHeaderHeight;

          // Add space between title and column headers on continuation pages
          tableCurrentY += 4;
        }

        // Draw column headers (AFTER the container header)
        doc.setTextColor(60, 60, 60);
        doc.setFontSize(8);
        doc.setFont("helvetica", "bold");
        doc.text("S.No", margin + 5, tableCurrentY, { align: "center" });
        doc.text("Product Name", margin + 12, tableCurrentY);
        doc.text("Rate", 95, tableCurrentY, { align: "center" });
        doc.text("Qty", 115, tableCurrentY, { align: "center" });
        doc.text("Total Rate", 135, tableCurrentY, { align: "center" });
        doc.text("Discount", 160, tableCurrentY, { align: "center" });
        doc.text("Final Rate", pageWidth - margin - 3, tableCurrentY, { align: "right" });

        doc.setDrawColor(200, 200, 200);
        doc.setLineWidth(0.3);
        doc.line(margin + 2, tableCurrentY + 2, pageWidth - margin - 2, tableCurrentY + 2);
        tableCurrentY += 6;

        // Draw products that fit on this page
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);

        const productsToDraw = remainingProducts.slice(0, rowsThatFit);
        remainingProducts = remainingProducts.slice(rowsThatFit);

        for (let i = 0; i < productsToDraw.length; i++) {
          const item = productsToDraw[i];

          // Zebra striping
          if (i % 2 === 0) {
            doc.setFillColor(252, 252, 252);
            doc.rect(margin + 1, tableCurrentY - 1, contentWidth - 2, 6, 'F');
          }

          const totalRate = item.originalPrice * item.quantity;
          const discountAmount = totalRate - item.subtotal;

          // S.No
          doc.setTextColor(60, 60, 60);
          doc.text((productIndex++).toString(), margin + 5, tableCurrentY + 2, { align: "center" });

          // Product name
          let itemName = item.name.length > 35 ? item.name.substring(0, 35) + '...' : item.name;
          doc.text(itemName, margin + 12, tableCurrentY + 2);

          // Rate
          doc.text(`Rs ${item.originalPrice.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`, 95, tableCurrentY + 2, { align: "center" });

          // Qty
          doc.text(item.quantity.toString(), 115, tableCurrentY + 2, { align: "center" });

          // Total Rate
          doc.text(`Rs ${totalRate.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`, 135, tableCurrentY + 2, { align: "center" });

          // Discounted Rate
          const displayDiscount = discountAmount > 0
            ? `Rs ${discountAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`
            : "-";
          doc.text(displayDiscount, 160, tableCurrentY + 2, { align: "center" });

          // Final Rate
          doc.setFont("helvetica", "bold");
          doc.text(`Rs ${item.subtotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`, pageWidth - margin - 3, tableCurrentY + 2, { align: "right" });
          doc.setFont("helvetica", "normal");

          tableCurrentY += 6;
        }

        // Add summary section if this is the last page of products
        if (remainingProducts.length === 0 && !summaryAdded) {
          if (!willDrawSummaryThisPage) {
            // Move to next page for summary
            doc.addPage();
            currentPage++;
            addPageHeader();
            tableCurrentY = 33;
            firstPage = false;
            continue;
          }

          tableCurrentY += 6;

          // Subtotal
          doc.setFillColor(249, 250, 251);
          doc.rect(margin + 3, tableCurrentY - 2, contentWidth - 6, 6, 'F');
          doc.setTextColor(75, 85, 99);
          doc.setFontSize(9);
          doc.setFont("helvetica", "bold");
          doc.text("Subtotal (MRP):", margin + 5, tableCurrentY + 2);
          doc.text(`Rs ${netTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`, pageWidth - margin - 5, tableCurrentY + 2, { align: "right" });
          tableCurrentY += 6;

          // Discount
          doc.setFillColor(240, 253, 244);
          doc.rect(margin + 3, tableCurrentY - 2, contentWidth - 6, 6, 'F');
          doc.setTextColor(34, 197, 94);
          doc.setFont("helvetica", "bold");
          doc.text("Discount:", margin + 5, tableCurrentY + 2);
          doc.text(`- Rs ${discountTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`, pageWidth - margin - 5, tableCurrentY + 2, { align: "right" });
          tableCurrentY += 8;

          // Total
          doc.setDrawColor(203, 213, 225);
          doc.setLineWidth(0.5);
          doc.line(margin + 5, tableCurrentY - 3, pageWidth - margin - 5, tableCurrentY - 3);

          doc.setTextColor(30, 58, 138);
          doc.setFontSize(11);
          doc.setFont("helvetica", "bold");
          doc.text("TOTAL AMOUNT:", margin + 5, tableCurrentY + 4);
          doc.setFontSize(12);
          doc.text(`Rs ${subTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`, pageWidth - margin - 5, tableCurrentY + 4, { align: "right" });

          summaryAdded = true;
          yPos = tableCurrentY + 25; // Update yPos for next content
        } else if (!summaryAdded) {
          // Move to next page for remaining products
          doc.addPage();
          currentPage++;
          addPageHeader();
          tableCurrentY = 33;
          firstPage = false;
        }
      }

      // === Footer on All Pages ===
      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        const footerY = pageHeight - 15;
        doc.setFillColor(248, 250, 252);
        doc.rect(0, footerY, pageWidth, 15, 'F');
        doc.setTextColor(100, 100, 100);
        doc.setFontSize(8);
        doc.setFont("helvetica", "bold");
        doc.text("Contact: +91-9787009888", margin, footerY + 9);
        doc.text("srigokilaacrackers0@gmail.com", pageWidth / 2, footerY + 9, { align: "center" });
        doc.text(`Generated: ${new Date().toLocaleString('en-GB')}`, pageWidth - margin, footerY + 9, { align: "right" });
      }

      // === Save & Return Blob ===
      doc.save(`${orderId}_SriGokilaaCrackers.pdf`);
      const pdfBlob = doc.output('blob');

      // Open in new tab
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setTimeout(() => {
        const viewWindow = window.open(pdfUrl, '_blank', 'width=1000,height=800');
        if (!viewWindow) alert("Please allow pop-ups.");
        setTimeout(() => URL.revokeObjectURL(pdfUrl), 10000);
      }, 500);

      return pdfBlob;
    };
    // Mobile responsive styles with proper media queries
    const getResponsiveStyles = () => ({
      container: {
        fontFamily: "'Poppins', sans-serif",
        backgroundColor: '#f8fafc',
        color: '#1e293b',
        lineHeight: 1.4,
        padding: isMobile ? '0.5rem' : '1rem',
        minHeight: 'calc(100vh - 100px)',
        position: 'relative', // Add this
        zIndex: 1, // Add this
      },
      wrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        margin: '0 auto',
        maxWidth: isMobile ? '100%' : '1200px',
        width: '100%',
      },
      orderCard: {
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: '1rem',
        width: '100%',
        minHeight: '400px',
        marginBottom: '2rem',
      },
      card: {
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        flex: 1,
      },
      cardHeader: {
        textAlign: 'center',
        padding: '0.6rem 0',
        backgroundColor: '#E6E9F8',
        color: '#2F3E9E',
      },
      cardTitle: {
        margin: 0,
        fontSize: isMobile ? '0.9rem' : '1rem',
        fontWeight: 600,
      },
      cardBody: {
        padding: isMobile ? '0.5rem' : '0.75rem',
        display: 'flex',
        flexDirection: 'column',
      },
      productList: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
        overflowY: 'auto',
        maxHeight: isMobile ? '300px' : '400px'
      },
      productItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #e2e8f0',
        padding: isMobile ? '0.4rem 0.25rem' : '0.4rem 0.5rem',
        flexWrap: isMobile ? 'wrap' : 'nowrap',
        gap: isMobile ? '0.25rem' : '0',
      },
      productInfo: {
        display: 'flex',
        alignItems: 'center',
        flex: isMobile ? '1 0 100%' : 1,
        marginBottom: isMobile ? '0.25rem' : 0,
      },
      productImage: {
        width: isMobile ? '35px' : '45px',
        height: isMobile ? '35px' : '45px',
        objectFit: 'cover',
        marginRight: isMobile ? '0.5rem' : '0.8rem',
        borderRadius: '0.375rem',
        border: '1px solid #e2e8f0',
      },
      productDetails: {
        flex: 1,
      },
      productName: {
        margin: 0,
        fontWeight: 600,
        fontSize: isMobile ? '0.75rem' : '0.8rem',
        color: '#1e293b',
        lineHeight: 1.2,
      },
      productMeta: {
        margin: '0.2rem 0 0',
        fontSize: isMobile ? '0.7rem' : '0.75rem',
        color: '#64748b',
      },
      productPrice: {
        fontWeight: 600,
        fontSize: isMobile ? '0.75rem' : '0.8rem',
        color: '#1e293b',
        minWidth: isMobile ? '60px' : '75px',
        textAlign: 'right',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.2rem',
        paddingRight: isMobile ? '0.25rem' : '0.5rem',
      },
      quantityInputStyle: {
        width: isMobile ? '35px' : '45px',
        padding: '0.3rem',
        border: '1px solid #ddd',
        borderRadius: '3px',
        textAlign: 'center',
        fontSize: isMobile ? '0.75rem' : '0.8rem'
      },
      totalsSection: {
        marginTop: '0.4rem',
        padding: isMobile ? '0.75rem' : '1rem',
        paddingBottom: '0.5rem',

      },
      totalRow: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '0.5rem',
        fontSize: isMobile ? '0.9rem' : '1rem',
      },
      totalLabel: {
        color: '#64748b',
        fontSize: isMobile ? '0.8rem' : '1rem',
      },
      totalValue: {
        fontWeight: 600,
        fontSize: isMobile ? '0.8rem' : '1rem',
        color: 'black',
      },
      grandTotal: {
        borderTop: '1px solid #cbd5e1',
        marginTop: '1rem',
        paddingTop: '1rem',
        fontWeight: 700,
        fontSize: isMobile ? '0.9rem' : '1.2rem',
        color: '#1e293b',
      },
      proceedButton: {
        backgroundColor: '#2F3E9E',
        color: 'white',
        padding: isMobile ? '0.5rem 0.5rem' : '0.5rem 1.1rem',
        border: 'none',
        borderRadius: '0.375rem',
        cursor: 'pointer',
        fontWeight: 600,
        fontSize: isMobile ? '0.95rem' : '0.9rem',
        transition: 'background-color 0.3s ease, transform 0.2s ease',
        alignSelf: 'center',
        width: isMobile ? '100%' : 'fit-content',
      },
      formContainer: {
        width: '100%',
      },
      formBody: {
        padding: isMobile ? '0.5rem' : '0.75rem',
      },
      formRow: {
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? '0.5rem' : '0.75rem',
        width: '100%',
        marginBottom: '0.5rem',
      },
      formGroup: {
        flex: 1,
        minWidth: 0,
      },
      fullWidth: {
        width: '100%',
      },
      formLabel: {
        display: 'block',
        width: '100%',
        marginBottom: '0.25rem',
        color: '#1e293b',
        fontSize: isMobile ? '0.8rem' : '0.85rem',
        fontWeight: 600,
      },
      formInput: {
        width: '100%',
        padding: isMobile ? '0.6rem' : '0.5rem',
        border: '1px solid #cbd5e1',
        borderRadius: '0.375rem',
        marginBottom: '0.25rem',
        fontSize: isMobile ? '0.9rem' : '0.85rem',
        transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
        boxSizing: 'border-box',
      },
      formAddress: {
        width: '100%',
        padding: isMobile ? '0.6rem' : '0.5rem',
        border: '1px solid #cbd5e1',
        borderRadius: '0.375rem',
        resize: 'vertical',
        minHeight: '2.5rem',
        fontSize: isMobile ? '0.9rem' : '0.85rem',
        transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
        boxSizing: 'border-box',
        marginBottom: '0.25rem',
      },
      checkboxContainer: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '0.25rem',
      },
      formCheckbox: {
        marginRight: '0.5rem',
        width: isMobile ? '18px' : '16px',
        height: isMobile ? '18px' : '16px',
      },
      sectionTitle: {
        fontSize: isMobile ? '0.9rem' : '0.95rem',
        fontWeight: 600,
        color: '#2F3E9E',
        marginBottom: '0.5rem',
        paddingBottom: '0.4rem',
        borderBottom: '1px solid #e2e8f0',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        transition: 'all 0.3s ease',
        padding: '0.4rem',
        borderRadius: '0.25rem',
      },
      sectionContent: {
        overflow: 'hidden',
        padding: '0.5rem',
      },
      sectionContentOpen: {
        maxHeight: '1000px',
        opacity: 1,
        marginBottom: '0.5rem',
      },
      sectionContentClosed: {
        maxHeight: '0px',
        opacity: 0,
        marginBottom: '0rem',
      },
      formDetailsColumns: {
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: '1rem',
      },
      formColumn: {
        flex: 1,
        border: '1px solid #e2e8f0',
        borderRadius: '0.375rem',
        padding: isMobile ? '0.5rem' : '0.75rem',
      },
      submitSection: {
        padding: isMobile ? '0.75rem' : '0.6rem',
      },
      termsSection: {
        backgroundColor: '#f8fafc',
        borderRadius: '0.5rem',
        paddingTop: '0.5rem',
        marginBottom: '1rem',
      },
      termsCheckbox: {
        marginRight: '0.5rem',
      },
      requiredField: {
        color: '#dc2626',
        marginLeft: '0.125rem',
      },
      actionButtons: {
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '0.75rem',
        gap: '0.75rem',
      },
      confirmButton: {
        backgroundColor: 'green',
        color: 'white',
        padding: isMobile ? '0.75rem 1.5rem' : '0.6rem 1.2rem',
        border: 'none',
        borderRadius: '0.375rem',
        cursor: 'pointer',
        fontWeight: 600,
        fontSize: isMobile ? '0.95rem' : '0.9rem',
        transition: 'background-color 0.3s ease, transform 0.2s ease',
        flex: 1,
        minWidth: isMobile ? '100%' : '120px',
        width: isMobile ? '100%' : 'auto',
      },
      cancelButton: {
        backgroundColor: '#94a3b8',
        color: 'white',
        padding: isMobile ? '0.75rem 1.5rem' : '0.6rem 1.2rem',
        border: 'none',
        borderRadius: '0.375rem',
        cursor: 'pointer',
        fontWeight: 600,
        fontSize: isMobile ? '0.95rem' : '0.9rem',
        transition: 'background-color 0.3s ease, transform 0.2s ease',
        flex: 1,
        minWidth: isMobile ? '100%' : '100px',
        width: isMobile ? '100%' : 'auto',
      },
      // Mobile-specific price layout
      mobileDiscountBadge: {
        color: '#10B981',
        fontSize: '0.7rem',
        fontWeight: 'bold',
        padding: '0.2rem 0.4rem',
        borderRadius: '0.25rem',
        backgroundColor: '#ecfdf5',
        border: '1px solid #10B981',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        marginTop: '0.25rem',
      },
      mobileQuantitySection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        marginTop: '0.25rem',
        paddingTop: '0.25rem',
        borderTop: '1px solid #f1f5f9',
      },
      mobilePriceSection: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: '0.2rem',
      },
      popupOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: isMobile ? '1rem' : '2rem',
      },
      popupContainer: {
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        maxWidth: isMobile ? '95%' : '600px',
        maxHeight: isMobile ? '90vh' : '80vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        overflow: 'hidden',
      },
      '@keyframes spin': {
        '0%': { transform: 'rotate(0deg)' },
        '100%': { transform: 'rotate(360deg)' }
      },
      popupHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: isMobile ? '0.75rem 1rem' : '1rem 1.5rem',
        borderBottom: '1px solid #e2e8f0',
        backgroundColor: '#f8fafc',
      },
      popupTitle: {
        margin: 0,
        fontSize: isMobile ? '1.1rem' : '1.25rem',
        color: '#1e293b',
      },
      popupCloseButton: {
        background: 'none',
        border: 'none',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        color: '#dc2626',
        cursor: 'pointer',
        width: '30px',
        height: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        transition: 'background-color 0.2s',
      },
      popupContent: {
        padding: isMobile ? '1rem' : '1.5rem',
        fontSize: isMobile ? '0.85rem' : '0.9rem',
        lineHeight: 1.5,
        color: '#334155',
        maxHeight: '60vh',
        overflowY: 'auto',
      },
      popupFooter: {
        padding: isMobile ? '0.75rem 1rem' : '1rem 1.5rem',
        borderTop: '1px solid #e2e8f0',
        backgroundColor: '#f8fafc',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
      }
    });

    const styles = getResponsiveStyles();

    const [showTermsPopup, setShowTermsPopup] = useState(false);

    const TermsPopup = () => (
      <div style={styles.popupOverlay}>
        <div style={styles.popupContainer}>
          <div style={styles.popupHeader}>
            <h2 style={styles.popupTitle}>
              Terms and Conditions
            </h2>
            <button
              onClick={() => setShowTermsPopup(false)}
              style={styles.popupCloseButton}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#f1f5f9')}
              onMouseOut={(e) => (e.target.style.backgroundColor = 'transparent')}
            >
              ×
            </button>
          </div>

          <div style={styles.popupContent}>
            <p style={{ marginTop: 0, marginBottom: '1rem' }}>
              Welcome to Sri Gokilaa Crackers. These Terms and Conditions govern your use of our website and services. Please read them carefully before placing an order.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong>1. Acceptance of Terms</strong><br />
              By accessing or using our services, you agree to be bound by these terms. If you do not agree, please do not use our services.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong>2. Orders and Payments</strong><br />
              All orders are subject to availability and confirmation of payment. We reserve the right to cancel any order at any time.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong>3. Shipping and Delivery</strong><br />
              We aim to dispatch your order within 1–2 business days. Delivery times may vary based on your location.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong>4. Returns and Refunds</strong><br />
              Due to the nature of our products, returns are only accepted in case of damaged or defective items.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong>5. Safety and Legal Compliance</strong><br />
              Fireworks are hazardous goods. You confirm that you are of legal age and responsible for complying with local laws regarding purchase and use.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong>6. Limitation of Liability</strong><br />
              In no event shall Vivify Traders be liable for any indirect, incidental, or consequential damages arising out of the use of our products.
            </p>
            <p style={{ marginBottom: '1rem' }}>
              <strong>7. Policy Updates</strong><br />
              We may update these terms from time to time. Continued use of the service constitutes acceptance of the updated terms.
            </p>
            <p style={{ marginBottom: 0 }}>
              <strong>8. Governing Law</strong><br />
              These Terms are governed by the laws of India. Any disputes shall be resolved in the courts of [City], India.
            </p>
          </div>

          {/* <div style={styles.popupFooter}>
          <input
            type="checkbox"
            id="agree-terms"
            style={{
              width: '18px',
              height: '18px',
              accentColor: '#1a237e',
              borderRadius: '4px',
            }}
          />
          <label htmlFor="agree-terms" style={{
            fontSize: isMobile ? '0.85rem' : '0.9rem',
            color: '#64748b',
          }}>
            I Agree
          </label>
        </div> */}
        </div>
      </div>
    );

    const CancelConfirmationPopup = () => (
      <div style={styles.popupOverlay}>
        <div style={{
          ...styles.popupContainer,
          maxWidth: isMobile ? '90%' : '400px',
        }}>
          <div style={styles.popupHeader}>
            <h3 style={{
              ...styles.popupTitle,
              fontSize: isMobile ? '1rem' : '1.2rem',
            }}>
              Cancel Order?
            </h3>
          </div>
          <div style={styles.popupContent}>
            <p style={{
              color: '#64748b',
              fontSize: isMobile ? '0.85rem' : '0.9rem',
              textAlign: 'center',
              marginBottom: 0,
            }}>
              Are you sure you want to cancel your order? All entered details and items will be cleared.
            </p>
          </div>
          <div style={{
            ...styles.popupFooter,
            justifyContent: 'center',
          }}>
            <button
              onClick={() => setShowCancelPopup(false)}
              style={{
                padding: isMobile ? '0.75rem 1.5rem' : '0.5rem 1rem',
                border: '1px solid #cbd5e1',
                backgroundColor: 'white',
                color: '#1e293b',
                borderRadius: '0.375rem',
                cursor: 'pointer',
                fontWeight: 500,
                fontSize: isMobile ? '0.9rem' : '0.85rem',
                minWidth: isMobile ? '100px' : '80px',
              }}
            >
              No
            </button>
            <button
              onClick={() => {
                // ✅ 1. Clear form data
                setFormData({
                  firstName: '',
                  lastName: '',
                  contactNumber: '',
                  whatsappNumber: '',
                  sameAsContact: false,
                  address: '',
                  city: '',
                  district: '',
                  state: '',
                  pinCode: '',
                  email: '',
                });
                // ✅ 2. Clear cart states
                setCartItems({});
                setCartProducts([]);
                // setQuantities({}); // ❌ Not needed — was causing error
                setSearchTerm('');
                // ✅ 3. Reset product quantities in productCategories
                setProductCategories(prev =>
                  prev.map(category => ({
                    ...category,
                    products: category.products.map(p => ({
                      ...p,
                      quantity: '',
                    })),
                  }))
                );

                // ✅ 4. Clear localStorage
                localStorage.removeItem('cart');

                // ✅ 5. Close all views
                setShowDetailsForm(false);
                setShowCancelPopup(false);
                setShowViewCart(false);

                // ✅ 6. Reset open sections
                setOpenSections({ personal: true, address: false, bank: false });

                // Optional: Scroll to top
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              style={{
                padding: isMobile ? '0.75rem 1.5rem' : '0.5rem 1rem',
                backgroundColor: '#dc2626',
                color: 'white',
                border: 'none',
                borderRadius: '0.375rem',
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: isMobile ? '0.9rem' : '0.85rem',
                minWidth: isMobile ? '100px' : '80px',
              }}
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    );

    // Load cart from localStorage on initial render
    useEffect(() => {
      const savedCart = localStorage.getItem('cart');
      if (savedCart) {
        setCartItems(JSON.parse(savedCart));
      }
    }, []);
    useEffect(() => {
      const handleResize = (e) => {
        setIsMobile(e.matches);
      };

      mobileMediaQuery.addListener(handleResize);
      return () => mobileMediaQuery.removeListener(handleResize);
    }, []);
    // Save cart to localStorage whenever it changes
    useEffect(() => {
      localStorage.setItem('cart', JSON.stringify(cartItems));
    }, [cartItems]);


    // FIX: Sync cartProducts from cartItems (localStorage) on load and update
    useEffect(() => {
      const loadCartFromStorage = () => {
        const savedCart = localStorage.getItem('cart');
        if (savedCart) {
          const parsedCart = JSON.parse(savedCart);
          setCartItems(parsedCart);
          // Convert cart items to cartProducts format using productCategories
          const products = [];
          Object.values(parsedCart).forEach((item) => {
            let found = false;
            productCategories.forEach((category) => {
              const product = category.products.find((p) => p.id === item.id);
              if (product) {
                products.push({
                  id: product.id,
                  name: product.prodName,
                  quantity: item.quantity,
                  price: product.discountPrice,
                  originalPrice: product.prodPrice,
                  subtotal: product.discountPrice * item.quantity,
                  image: product.prodImage,
                  discountPercent: getDiscountPercent(
                    product.prodPrice,
                    product.discountPrice,
                    product.discountPercentage
                  ),
                });
                found = true;
              }
            });

            // Fallback if product not found (e.g., outdated cart)
            if (!found) {
              products.push({
                id: item.id,
                name: `Product #${item.id}`,
                quantity: item.quantity,
                price: 0,
                originalPrice: 0,
                subtotal: 0,
                image: "https://via.placeholder.com/60",
                discountPercent: 0,
              });
            }
          });
          setCartProducts(products);
        }
      };

      loadCartFromStorage();
    }, [productCategories]); // Re-sync when product data loads
    useEffect(() => {
      localStorage.setItem('cart', JSON.stringify(cartItems));
    }, [cartItems]);

    // Update cartItems from URL state (if passed)
    useEffect(() => {
      if (location.state?.cartItems) {
        setCartItems(location.state.cartItems);
        localStorage.setItem('cart', JSON.stringify(location.state.cartItems));
      }
    }, [location.state]);

    // Fetch products from API
    useEffect(() => {
      const fetchProducts = async () => {
        try {
          setLoading(true);
          setError(null);

          const response = await axios.get(`${API_BASE_URL}api/Crackers/GetProductSummary?CompanyId=1`);

          if (response.data.statusCode === 200 && Array.isArray(response.data.result)) {
            const products = response.data.result;

            // 👉 Safely group by categoryName
            const grouped = products.reduce((acc, product) => {
              if (!product?.categoryName) return acc; // Skip invalid products

              const { categoryName } = product;
              if (!acc[categoryName]) {
                acc[categoryName] = []; // Initialize as array
              }

              acc[categoryName].push({
                ...product,
                quantity: '',
                prodPrice: parseFloat(product.prodPrice?.toFixed(3)) || 0,
                discountPrice: parseFloat(product.discountPrice?.toFixed(3)) || 0,
                discountPercentage: parseFloat(product.discountPercentage?.toFixed(1)) || 0,
              });
              return acc;
            }, {});

            // 👉 Convert to array of { name, products[] }
            const categoriesArray = Object.entries(grouped).map(([name, products]) => ({
              name,
              products: Array.isArray(products) ? products : [] // Ensure products is always an array
            }));

            setProductCategories(categoriesArray);
          } else {
            setError("Failed to load products.");
          }
        } catch (err) {
          console.error("Error fetching products:", err);
          setError("Error loading products. Please refresh.");
        } finally {
          setLoading(false);
        }
      };
      fetchProducts();
    }, []);



    // Handle quantity change in product list
    const handleQuantityChange = (productId, value) => {
      // Handle empty quantity field
      if (value === '') {
        // Update product categories to clear quantity
        setProductCategories((prev) => {
          const newCategories = [...prev];
          newCategories.forEach((category) =>
            category.products.forEach((p) => {
              if (p.id === productId) p.quantity = '';
            })
          );
          return newCategories;
        });

        // Remove from cartItems (localStorage)
        setCartItems((prev) => {
          const newCart = { ...prev };
          delete newCart[productId];
          return newCart;
        });

        // Remove from cartProducts if exists
        setCartProducts(prevProducts =>
          prevProducts.filter(p => p.id !== productId)
        );

        return;
      }

      const numValue = parseInt(value, 10);

      // If invalid number, keep the field value but don't update cart
      if (isNaN(numValue)) return;

      // Minimum quantity is 1
      const newQuantity = Math.max(1, numValue);

      // Update product categories
      setProductCategories((prev) => {
        const newCategories = [...prev];
        newCategories.forEach((category) =>
          category.products.forEach((p) => {
            if (p.id === productId) p.quantity = newQuantity;
          })
        );
        return newCategories;
      });

      // Find product details
      let productDetails = null;
      for (const category of productCategories) {
        const prod = category.products.find((p) => p.id === productId);
        if (prod) {
          productDetails = prod;
          break;
        }
      }

      if (productDetails) {
        const effectivePrice = (productDetails.discountPrice && productDetails.discountPrice > 0) ? productDetails.discountPrice : productDetails.prodPrice;
        
        // Update cartItems (localStorage)
        setCartItems((prev) => ({
          ...prev,
          [productId]: {
            id: productId,
            quantity: newQuantity,
            name: productDetails.prodName,
            price: effectivePrice,
            originalPrice: productDetails.prodPrice,
            image: productDetails.prodImage,
          },
        }));

        // Update or add to cartProducts
        setCartProducts(prevProducts => {
          const existingProduct = prevProducts.find(p => p.id === productId);
          if (existingProduct) {
            return prevProducts.map(product =>
              product.id === productId
                ? {
                  ...product,
                  quantity: newQuantity,
                  subtotal: product.price * newQuantity
                }
                : product
            );
          } else {
            return [
              ...prevProducts,
              {
                id: productId,
                name: productDetails.prodName,
                quantity: newQuantity,
                price: effectivePrice,
                originalPrice: productDetails.prodPrice,
                subtotal: effectivePrice * newQuantity,
                image: productDetails.prodImage,
                discountPercent: getDiscountPercent(
                  productDetails.prodPrice,
                  productDetails.discountPrice,
                  productDetails.discountPercentage
                ),
              }
            ];
          }
        });
      }
    };


    useEffect(() => {
      const loadCartItems = () => {
        const savedCart = localStorage.getItem('cart');
        if (savedCart) {
          setCartItems(JSON.parse(savedCart));

          // If there are cart items, send them to the API
          if (Object.keys(JSON.parse(savedCart)).length > 0) {

          }
        }
      };

      loadCartItems();
    }, []);

    const calculateProductTotal = (price, quantity) => {
      if (!quantity || quantity === '') return '0.00';
      const total = (price * quantity).toFixed(3); // Calculate with 3 decimal places
      return formatPrice(total); // Format with 2 decimal places
    };

    const calculateOverallTotal = () => {
      return Object.values(cartItems).reduce((sum, item) => {
        return sum + (item.price * item.quantity);
      }, 0);
    };

    const calculateOriginalTotal = () => {
      return Object.values(cartItems).reduce((sum, item) => {
        return sum + (item.originalPrice * item.quantity);
      }, 0);
    };

    const calculateTotalSavings = () => {
      const originalTotal = calculateOriginalTotal();
      const discountedTotal = calculateOverallTotal();
      return originalTotal - discountedTotal;
    };

    const calculateProductCount = () => {
      return Object.keys(cartItems).length;
    };




    const filteredCategories = searchTerm
      ? productCategories.map(category => ({
        ...category,
        products: category.products.filter(product =>
          product.prodName.toLowerCase().includes(searchTerm.toLowerCase())
        )
      })).filter(category => category.products.length > 0)
      : productCategories;

    const formatPrice = (price) => {
      if (!price) return '0.00';
      const numValue = typeof price === 'string' ?
        parseFloat(price.replace(/,/g, '')) :
        price;
      return new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(numValue);
    };
    // Replace the existing getDiscountPercent function with this:
    const getDiscountPercent = (marketPrice, discountPrice, apiDiscountPercent) => {
      // Ensure inputs are valid numbers
      const validMarketPrice = typeof marketPrice === 'number' && !isNaN(marketPrice) ? marketPrice : 0;
      const validDiscountPrice = typeof discountPrice === 'number' && !isNaN(discountPrice) ? discountPrice : 0;

      // First try to calculate from the actual prices if they exist
      if (validMarketPrice > 0 && validDiscountPrice > 0) {
        const calculatedDiscount = ((validMarketPrice - validDiscountPrice) / validMarketPrice) * 100;
        // Only use the calculated discount if it makes sense (between 1% and 100%)
        if (calculatedDiscount >= 1 && calculatedDiscount <= 100) {
          return Math.round(calculatedDiscount);
        }
      }
      // Fallback to API's discount percentage if it exists and is valid
      if (
        apiDiscountPercent !== undefined &&
        apiDiscountPercent !== null &&
        apiDiscountPercent >= 1 &&
        apiDiscountPercent <= 100
      ) {
        return Math.round(apiDiscountPercent);
      }
      // Default to 0 if no valid discount can be determined
      return 0;
    };
    if (loading) {
      return (
        <>
          <Header />
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            Loading products...
          </div>
          <Footer />
        </>
      );
    }

    if (error) {
      return (
        <>
          <Header />
          <div style={{ textAlign: 'center', padding: '2rem', color: '#d32f2f' }}>
            {error}
          </div>
          <Footer />
        </>
      );
    }

    return (
      <>
        <Header />
        {!showDetailsForm && !showViewCart && (
          <div style={{
            minHeight: '100vh',
            paddingBottom: '1rem',
            margin: '0'
          }}>

            {/* Hero Section */}


            {/* Main Content */}
            <div style={{
              minHeight: 'calc(100vh - 160px)',
              padding: '0',
              margin: '0',
              position: 'relative'
            }}>


              <motion.div
                style={{
                  display: 'flex',
                  flexDirection: mobileMediaQuery.matches ? 'column' : 'row',
                  justifyContent: 'space-between',
                  alignItems: mobileMediaQuery.matches ? 'flex-start' : 'center',
                  padding: '0.4rem 0.8rem', // Reduced padding
                  background: 'linear-gradient(135deg, rgb(6, 7, 44) 0%, rgb(16, 26, 94) 100%)',
                  borderRadius: '8px',
                  margin: '0.8rem',
                  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.15)',
                  gap: mobileMediaQuery.matches ? '0.6rem' : '0.8rem', // Reduced gap
                  width: 'calc(100% - 1.6rem)', // Adjusted width calculation
                  marginLeft: '0.1rem',
                  marginRight: '1rem',
                  position: 'sticky',
                  top: '80px',
                  zIndex: 100,
                  marginTop: '10px', // Removed extra margin-top
                }}
              >
                {/* Search Input */}
                <div style={{
                  position: 'relative',
                  width: mobileMediaQuery.matches ? '100%' : '300px',
                  minWidth: mobileMediaQuery.matches ? '100%' : '200px',
                  flex: mobileMediaQuery.matches ? '0 1 auto' : '1 1 auto',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  <FiSearch style={{
                    position: 'absolute',
                    left: '0.8rem',
                    color: 'rgba(255,255,255,0.9)',
                    fontSize: '1rem'
                  }} />
                  <input
                    type="text"
                    placeholder="Search products..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '0.3rem 0.8rem 0.3rem 2.2rem',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: 'clamp(0.8rem, 2vw, 0.85rem)',
                      background: 'rgba(255,255,255,0.2)',
                      color: 'white',
                      transition: 'all 0.3s',
                      outline: 'none',
                      '::placeholder': {
                        color: 'rgba(255,255,255,0.7)'
                      }
                    }}
                  />
                </div>
                {/* Summary Section */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'clamp(0.5rem, 2vw, 1rem)',
                  flexWrap: mobileMediaQuery.matches ? 'wrap' : 'nowrap',
                  justifyContent: mobileMediaQuery.matches ? 'space-between' : 'flex-end',
                  flex: '1 1 auto',
                  width: mobileMediaQuery.matches ? '100%' : 'auto'
                }}>
                  {/* Checkout Button */}
                  <motion.button
                    whileHover={{ scale: 1.03, boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)' }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => {
                      const productCount = calculateProductCount();
                      if (productCount === 0) {
                        alert("No items selected. Please add at least one product to proceed.");
                        return;
                      }
                      setShowViewCart(true);
                      setTimeout(() => {
                        if (viewCartRef.current) {
                          const headerHeight = document.querySelector('header')?.offsetHeight || 0;
                          window.scrollTo({
                            top: viewCartRef.current.offsetTop - headerHeight - 20,
                            behavior: 'smooth',
                          });
                        }
                      }, 100);
                    }}
                    style={{
                      padding: '0.6rem clamp(0.8rem, 2vw, 1.2rem)',
                      background: 'linear-gradient(135deg, #f5af19 0%, #f12711 100%)',
                      color: 'white',
                      fontWeight: '600',
                      borderRadius: '6px',
                      border: 'none',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.4rem',
                      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                      fontSize: 'clamp(0.8rem, 2vw, 0.85rem)',
                      transition: 'all 0.2s',
                      order: mobileMediaQuery.matches ? -1 : 0,
                      width: mobileMediaQuery.matches ? '100%' : 'auto',
                      justifyContent: 'center',
                      marginBottom: mobileMediaQuery.matches ? '0.5rem' : '0',
                      textShadow: '0 1px 2px rgba(0, 0, 0, 0.2)'
                    }}
                  >
                    <FiShoppingCart size={15} />
                    Checkout
                  </motion.button>

                  {/* Items Count */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.3rem',
                    order: mobileMediaQuery.matches ? 0 : 1
                  }}>
                    <div style={{
                      fontSize: 'clamp(0.75rem, 2vw, 0.8rem)',
                      fontWeight: '500',
                      color: 'rgba(255,255,255,0.9)'
                    }}>Items:</div>
                    <div style={{
                      fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                      fontWeight: '700',
                      color: 'white',
                      minWidth: '25px',
                      textAlign: 'center'
                    }}>{calculateProductCount()}</div>
                  </div>

                  {/* MRP */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.3rem',
                    order: mobileMediaQuery.matches ? 1 : 2
                  }}>
                    <div style={{
                      fontSize: 'clamp(0.75rem, 2vw, 0.8rem)',
                      fontWeight: '500',
                      color: 'rgba(255,255,255,0.9)'
                    }}>MRP:</div>
                    <div style={{
                      fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                      fontWeight: '700',
                      color: '#ff6b6b',
                      minWidth: '70px',
                      textAlign: 'center',
                      textDecoration: calculateTotalSavings() > 0 ? 'line-through' : 'none'
                    }}>₹{formatPrice(calculateOriginalTotal())}</div>
                  </div>

                  {/* Discount Badge */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.3rem',
                    background: 'rgba(0,0,0,0.3)',
                    padding: '0.3rem 0.6rem',
                    borderRadius: '4px',
                    border: '1px solid rgba(255,255,255,0.1)',
                    order: mobileMediaQuery.matches ? 3 : 3
                  }}>
                    <div style={{
                      fontSize: 'clamp(0.7rem, 2vw, 0.75rem)',
                      fontWeight: '600',
                      color: '#00ff88',
                      whiteSpace: 'nowrap'
                    }}>
                      Discount ₹{formatPrice(calculateTotalSavings())}
                    </div>
                  </div>

                  {/* Total Amount */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.3rem',
                    order: mobileMediaQuery.matches ? 2 : 4
                  }}>
                    <div style={{
                      fontSize: 'clamp(0.75rem, 2vw, 0.8rem)',
                      fontWeight: '500',
                      color: 'rgba(255,255,255,0.9)'
                    }}>Total:</div>
                    <div style={{
                      fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                      fontWeight: '700',
                      color: 'white',
                      minWidth: '70px',
                      textAlign: 'center'
                    }}>₹{formatPrice(calculateOverallTotal())}</div>
                  </div>
                </div>
              </motion.div>



              {/* Products Table */}
              <motion.div
                className="product-table-anchor"  // 👈 Add this class
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.5 }}
                style={{
                  background: '#ffffff',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                  overflow: 'hidden',
                  margin: '0 0.8rem 1rem',
                  position: 'relative',
                  maxHeight: 'calc(125vh - 325px)',
                  display: 'flex',
                  flexDirection: 'column',
                  isolation: 'isolate', // This creates a new stacking context
                }}
              >
                <div style={{
                  overflow: 'auto',
                  scrollbarWidth: 'thin',
                  scrollbarColor: '#2c3e50 #ecf0f1',
                  flex: 1,
                  '&::-webkit-scrollbar': {
                    width: '8px',
                    height: '8px'
                  },
                  '&::-webkit-scrollbar-track': {
                    background: '#ecf0f1'
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#2c3e50',
                    borderRadius: '4px'
                  }
                }}>
                  <table style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    fontFamily: 'sans-serif',
                    fontSize: isMobile ? '0.75rem' : '0.8rem',
                    background: '#ffffff',
                    tableLayout: 'auto'
                  }}>
                    {/* Table Head */}
                    <thead>
                      <tr style={{
                        background: '#3949AB',
                        position: 'sticky',
                        top: '0', // Stick to top of table container
                        zIndex: 2, // Lower than popups but above content
                        borderBottom: '2px solid #34495e'
                      }}>
                        <th style={{
                          padding: isMobile ? '0.4rem 0.2rem' : '0.6rem 0.4rem',
                          display: isMobile ? 'none' : 'table-cell',
                          color: 'white',
                          width: isMobile ? '0%' : '5%'
                        }}>S.NO.</th>

                        <th style={{
                          padding: isMobile ? '0.4rem 0.3rem' : '0.6rem 0.5rem',
                          color: 'white',
                          textAlign: 'left',
                          width: isMobile ? '28%' : '20%',
                          fontSize: isMobile ? '0.64rem' : '0.75rem'
                        }}>PRODUCT</th>

                        <th style={{
                          padding: isMobile ? '0.4rem 0.1rem' : '0.6rem 0.3rem',
                          color: 'white',
                          width: isMobile ? '10%' : '8%',
                          textAlign: 'center',
                          fontSize: isMobile ? '0.64rem' : '0.75rem'
                        }}>UNIT</th>

                        <th style={{
                          padding: isMobile ? '0.4rem 0.1rem' : '0.6rem 0.3rem',
                          color: 'white',
                          width: isMobile ? '10%' : '10%',
                          textAlign: 'center',
                          fontSize: isMobile ? '0.64rem' : '0.75rem'
                        }}>{isMobile ? 'MRP' : 'MRP ₹'}</th>

                        <th style={{
                          padding: isMobile ? '0.4rem 0.1rem' : '0.6rem 0.3rem',
                          color: 'white',
                          width: isMobile ? '15%' : '12%',
                          textAlign: 'center',
                          fontSize: isMobile ? '0.64rem' : '0.75rem'
                        }}>{isMobile ? 'DISCOUNT' : 'DISCOUNT ₹'}</th>

                        <th style={{
                          padding: isMobile ? '0.4rem 0.1rem' : '0.6rem 0.3rem',
                          color: 'white',
                          width: isMobile ? '10%' : '10%',
                          textAlign: 'center',
                          fontSize: isMobile ? '0.64rem' : '0.75rem'
                        }}>QTY</th>

                        <th style={{
                          padding: isMobile ? '0.4rem 0.1rem' : '0.6rem 0.3rem',
                          color: 'white',
                          width: isMobile ? '14%' : '10%',
                          textAlign: 'center',
                          fontSize: isMobile ? '0.64rem' : '0.75rem'
                        }}>TOTAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredCategories.length > 0 ? (
                        filteredCategories.map((category, catIndex) => (
                          <React.Fragment key={`cat-${catIndex}`}>
                            {/* Category Header Row */}
                            <tr style={{
                              background: 'linear-gradient(to right, #F5F5F5, #E0E0E0)',
                              borderTop: '1px solid #E0E0E0',
                              borderBottom: '2px solid #B0B0B0',

                              top: '32px', // Below the main table header
                              zIndex: 1, // Below main header but above content
                            }}>
                              <td style={{
                                padding: isMobile ? '0.4rem 0.6rem' : '0.6rem 0.8rem',
                                fontSize: isMobile ? '0.7rem' : '0.8rem',
                                fontWeight: '790',
                                color: '#FF6D00',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                textShadow: '0 1px 1px rgba(255,255,255,0.8)'
                              }} colSpan={isMobile ? "6" : "7"}>
                                {category.name}
                              </td>
                            </tr>

                            {/* Products under this category */}
                            {category.products.map((product, prodIndex) => {
                              const discountPercent = getDiscountPercent(product.prodPrice, product.discountPrice, product.discountPercentage);
                              const effectivePrice = (product.discountPrice && product.discountPrice > 0) ? product.discountPrice : product.prodPrice;
                              const rowColor = prodIndex % 2 === 0 ? '#ffffff' : '#f8f9fa';

                              return (
                                <motion.tr
                                  key={product.id}
                                  whileHover={{
                                    background: '#e8f4fc'
                                  }}
                                  transition={{ duration: 0.2 }}
                                  style={{
                                    background: rowColor,
                                    borderBottom: '1px solid #e0e0e0'
                                  }}
                                >
                                  {/* S.NO - Hidden on mobile */}
                                  <td style={{
                                    padding: isMobile ? '0.4rem 0.2rem' : '0.6rem 0.3rem',
                                    fontSize: isMobile ? '0.65rem' : '0.75rem',
                                    fontWeight: '500',
                                    color: '#34495e',
                                    textAlign: 'center',
                                    display: isMobile ? 'none' : 'table-cell'
                                  }}>
                                    {prodIndex + 1}.
                                  </td>

                                  {/* PRODUCT NAME */}
                                  {/* PRODUCT NAME */}
                                  <td style={{
                                    padding: isMobile ? '0.4rem 0.4rem' : '0.6rem 0.5rem',
                                    fontSize: isMobile ? '0.65rem' : '0.75rem',
                                    fontWeight: '600',
                                    color: '#2c3e50',
                                    textAlign: 'left',
                                    wordBreak: 'break-word'
                                  }}>
                                    {product.prodName}
                                    {product.pieces > 0 && ` (${product.pieces} Pieces)`}
                                  </td>

                                  {/* UNIT */}
                                  <td style={{
                                    padding: isMobile ? '0.4rem 0.2rem' : '0.6rem 0.3rem',
                                    fontSize: isMobile ? '0.65rem' : '0.75rem',
                                    color: '#7f8c8d',
                                    textAlign: 'center'
                                  }}>
                                    {product.unitName || '1 Box'}
                                  </td>

                                  {/* MRP ₹ */}
                                  <td style={{
                                    padding: isMobile ? '0.4rem 0.2rem' : '0.6rem 0.3rem',
                                    fontSize: isMobile ? '0.65rem' : '0.75rem',
                                    fontWeight: '500',
                                    color: '#e74c3c',
                                    textDecoration: (product.prodPrice > product.discountPrice && discountPercent > 0) ? 'line-through' : 'none',
                                    textAlign: 'center'
                                  }}>
                                    {formatPrice(product.prodPrice)}
                                  </td>

                                  {/* DISCOUNT ₹ */}
                                  <td style={{
                                    padding: isMobile ? '0.4rem 0.2rem' : '0.6rem 0.3rem',
                                    fontSize: isMobile ? '0.65rem' : '0.75rem',
                                    fontWeight: '700',
                                    color: 'grey',
                                    textAlign: 'center'
                                  }}>
                                    <div>
                                      {discountPercent > 0 ? (
                                        <>
                                          {formatPrice(effectivePrice)}
                                          <div style={{
                                            fontSize: '0.6rem',
                                            color: '#27ae60',
                                            fontWeight: '600',
                                            marginTop: '2px'
                                          }}>
                                            ({discountPercent}% OFF)
                                          </div>
                                        </>
                                      ) : (
                                        '-'
                                      )}
                                    </div>
                                  </td>

                                  {/* QTY */}
                                  <td style={{
                                    padding: isMobile ? '0.4rem 0.2rem' : '0.6rem 0.3rem',
                                    textAlign: 'center'
                                  }}>
                                    <motion.input
                                      whileFocus={{ scale: 1.03 }}
                                      type="number"
                                      placeholder='QTY'
                                      min="0"
                                      value={product.quantity}
                                      onChange={(e) => handleQuantityChange(product.id, e.target.value)}
                                      style={{
                                        width: isMobile ? '35px' : '45px',
                                        padding: isMobile ? '0.25rem' : '0.3rem',
                                        border: '1px solid #bdc3c7',
                                        borderRadius: '4px',
                                        background: '#ffffff',
                                        color: '#2c3e50',
                                        textAlign: 'center',
                                        fontSize: isMobile ? '0.65rem' : '0.7rem',
                                        fontWeight: '500',
                                        transition: 'all 0.2s',
                                        ':focus': {
                                          outline: 'none',
                                          borderColor: '#3498db',
                                          boxShadow: '0 0 0 2px rgba(52,152,219,0.2)'
                                        },
                                        '::placeholder': {
                                          color: '#95a5a6'
                                        }
                                      }}
                                    />
                                  </td>

                                  {/* TOTAL */}
                                  <td style={{
                                    padding: isMobile ? '0.4rem 0.2rem' : '0.6rem 0.3rem',
                                    fontSize: isMobile ? '0.65rem' : '0.75rem',
                                    fontWeight: '700',
                                    color: product.quantity > 0 ? '#2c3e50' : '#95a5a6',
                                    textAlign: 'center',
                                    transition: 'all 0.3s'
                                  }}>
                                    {product.quantity ? calculateProductTotal(effectivePrice, product.quantity) : '0.00'}
                                  </td>
                                </motion.tr>
                              );
                            })}
                          </React.Fragment>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={isMobile ? "6" : "7"} style={{
                            padding: '1rem',
                            textAlign: 'center',
                            color: '#7f8c8d',
                            background: '#ffffff',
                            fontSize: '0.8rem'
                          }}>
                            No products found matching your search.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </motion.div>
            </div>
          </div>
        )}

        {/* ViewCart section */}

        {showViewCart && (
          <div ref={viewCartRef} style={styles.container}>

            <div style={styles.wrapper}>
              <div style={styles.orderCard}>
                {/* Left Card - Order Items */}
                <div style={{ ...styles.card, flex: isMobile ? 1 : 3 }}>
                  <div style={styles.cardHeader}>
                    <h2 style={styles.cardTitle}>Your Order</h2>
                  </div>

                  <div style={styles.cardBody}>
                    <ul style={styles.productList}>
                      {cartProducts.map((product) => (
                        <li key={product.id} style={{ ...styles.productItem, position: 'relative' }}>
                          {/* Improved Remove button */}

                          <button
                            style={{
                              position: 'absolute',
                              right: '1px',  // Moved slightly right from edge
                              top: '-4px',    // Moved slightly down from top
                              cursor: 'pointer',
                              color: '#b91c1c', // Darker red color
                              zIndex: 1,
                              background: 'none',
                              border: 'none',
                              padding: '2px',
                              fontSize: '14px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: '18px',
                              height: '18px',
                              fontWeight: 'bold' // Made icon bold
                            }}
                            // In the remove button onClick handler:
                            onClick={() => {
                              // Remove from cartProducts state
                              setCartProducts(prevProducts =>
                                prevProducts.filter(p => p.id !== product.id)
                              );

                              // Remove from cartItems (localStorage)
                              setCartItems(prev => {
                                const newCart = { ...prev };
                                delete newCart[product.id];
                                return newCart;
                              });

                              // Also update productCategories to reset quantity
                              setProductCategories(prevCategories =>
                                prevCategories.map(category => ({
                                  ...category,
                                  products: category.products.map(p =>
                                    p.id === product.id ? { ...p, quantity: "" } : p
                                  )
                                }))
                              );
                            }}
                          >
                            <FiX />
                          </button>


                          <div style={styles.productInfo}>
                            <img
                              src={product.image || "https://via.placeholder.com/60"}
                              alt={product.name}
                              style={styles.productImage}
                            />
                            <div style={{
                              ...styles.productDetails,
                              flex: isMobile ? '1 0 100%' : 1,
                              marginRight: isMobile ? '20px' : '0',
                              paddingRight: isMobile ? '30px' : '0' // Add padding to prevent text overlap
                            }}>
                              <p style={{
                                ...styles.productName,
                                fontSize: isMobile ? '0.7rem' : '0.8rem',
                                marginBottom: isMobile ? '0.3rem' : '0.2rem',
                                paddingRight: '10px' // Add padding to prevent text overlap
                              }}>
                                {product.name}
                              </p>

                              {/* Mobile-only price display */}
                              {isMobile && (
                                <div style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '0.5rem',
                                  marginTop: '0.2rem'
                                }}>
                                  <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                  }}>
                                    {product.discountPercent > 0 && (
                                      <span style={{
                                        textDecoration: 'line-through',
                                        color: '#64748b',
                                        fontSize: '0.65rem'
                                      }}>
                                        ₹{formatPrice(product.originalPrice)}
                                      </span>
                                    )}
                                    <span style={{
                                      fontWeight: 'bold',
                                      fontSize: '0.7rem'
                                    }}>
                                      ₹{formatPrice(product.price)}
                                    </span>
                                  </div>

                                  {product.discountPercent > 0 && (
                                    <div style={{
                                      color: '#10B981',
                                      fontSize: '0.65rem',
                                      fontWeight: 'bold',
                                      padding: '0.15rem 0.3rem',
                                      borderRadius: '0.25rem',
                                      backgroundColor: '#ecfdf5',
                                      border: '1px solid #10B981',
                                    }}>
                                      Save {product.discountPercent}%
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>

                            {/* Desktop price display */}
                            {!isMobile && (
                              <div style={styles.productDetails}>
                                <div style={{
                                  display: 'flex',
                                  gap: '0.5rem',
                                  alignItems: 'center',
                                  width: '100%',
                                  fontSize: '0.85rem',
                                }}>
                                  <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                  }}>
                                    {product.discountPercent > 0 && (
                                      <span style={{
                                        textDecoration: 'line-through',
                                        color: '#64748b',
                                        fontSize: '0.75rem'
                                      }}>
                                        ₹{formatPrice(product.originalPrice)}
                                      </span>
                                    )}
                                    <span style={{
                                      fontWeight: 'bold',
                                      fontSize: '0.75rem'
                                    }}>
                                      ₹{formatPrice(product.price)}
                                    </span>
                                  </div>

                                  {product.discountPercent > 0 && (
                                    <div style={{
                                      color: '#10B981',
                                      fontSize: '0.75rem',
                                      fontWeight: 'bold',
                                      padding: '0.25rem 0.5rem',
                                      borderRadius: '0.375rem',
                                      textAlign: 'center',
                                      whiteSpace: 'nowrap',
                                    }}>
                                      Save {product.discountPercent}%
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>

                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            minWidth: isMobile ? '100%' : '70px',
                            justifyContent: isMobile ? 'space-between' : 'center',
                            gap: '0.5rem',
                            marginTop: isMobile ? '0.3rem' : 0,
                            paddingTop: isMobile ? '0.3rem' : 0,
                            borderTop: isMobile ? '1px solid #f1f5f9' : 'none',
                            paddingRight: isMobile ? '30px' : '0' // Add padding to prevent overlap
                          }}>
                            {isMobile && (
                              <span style={{
                                fontSize: '0.7rem',
                                color: '#64748b'
                              }}>Qty:</span>
                            )}
                            <input
                              type="number"
                              min="1" // Changed from type="number" to allow empty value
                              value={product.quantity || ""}
                              onChange={(e) => {
                                // Allow empty value or numeric input
                                const value = e.target.value;
                                if (value === "" || /^[0-9\b]+$/.test(value)) {
                                  updateQuantity(product.id, value, product.quantity);
                                }
                              }}
                              onBlur={(e) => {
                                // When field loses focus, ensure minimum quantity is 1 if not empty
                                if (e.target.value !== "" && parseInt(e.target.value) < 1) {
                                  updateQuantity(product.id, "1", product.quantity);
                                }
                              }}
                              style={styles.quantityInputStyle}
                            />

                            {isMobile && (
                              <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-end'
                              }}>
                                {product.discountPercent > 0 && (
                                  <div style={{
                                    textDecoration: 'line-through',
                                    color: '#64748b',
                                    fontSize: '0.65rem'
                                  }}>
                                    ₹{formatPrice(product.originalPrice * product.quantity)}
                                  </div>
                                )}
                                <div style={{
                                  fontSize: '0.8rem',
                                  fontWeight: 'bold'
                                }}>
                                  ₹{formatPrice(product.subtotal)}
                                </div>
                              </div>
                            )}
                          </div>

                          {!isMobile && (
                            <div style={styles.productPrice}>
                              {product.discountPercent > 0 && (
                                <div style={{ textDecoration: 'line-through', color: '#64748b', fontSize: '0.75rem' }}>
                                  ₹{formatPrice(product.originalPrice * product.quantity)}
                                </div>
                              )}
                              <div>₹{formatPrice(product.subtotal)}</div>
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Right Card - Price Details */}
                <div style={{ ...styles.card, flex: isMobile ? 1 : 2 }}>
                  <div style={styles.cardHeader}>
                    <h2 style={styles.cardTitle}>Price Details</h2>
                  </div>

                  <div style={{
                    ...styles.totalsSection, display: 'flex',
                    flexDirection: 'column',
                    height: '80%',
                    justifyContent: 'space-between'
                  }}>
                    <div style={styles.totalRow}>
                      <span style={styles.totalLabel}>Price ({cartProducts.length} item{cartProducts.length !== 1 ? 's' : ''})</span>
                      <span style={styles.totalValue}>₹{formatPrice(netTotal)}</span>
                    </div>
                    <div style={styles.totalRow}>
                      <span style={styles.totalLabel}>Discount</span>
                      <span style={{ ...styles.totalValue, color: '#10B981' }}>-₹{formatPrice(discountTotal)}</span>
                    </div>
                    <div style={{ ...styles.totalRow, ...styles.grandTotal }}>
                      <span>Total Amount</span>
                      <span>₹{formatPrice(subTotal)}</span>
                    </div>

                    {/* Add the minimum amount warning */}
                    {amountBelowMinimum && (
                      <div style={{
                        color: '#dc2626',
                        fontSize: isMobile ? '0.8rem' : '0.85rem',
                        textAlign: 'center',
                        margin: '0.5rem 0',
                        padding: '0.5rem',
                        backgroundColor: '#fee2e2',
                        borderRadius: '0.25rem'
                      }}>
                        Total pay amount must be at least ₹3000
                      </div>
                    )}

                    <div style={{
                      padding: isMobile ? '0.75rem' : '0.1rem',
                      textAlign: 'center',
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginBottom: '0.5rem',
                      gap: isMobile ? '0.5rem' : '0',
                      marginTop: 'auto',
                    }}>
                      <button
                        style={styles.proceedButton}
                        onClick={() => {
                          // Always: close both cart and form
                          setShowViewCart(false);
                          setShowDetailsForm(false);

                          // Optional: Scroll back to top of products
                          const productTable = document.querySelector('.product-table-anchor');
                          if (productTable) {
                            const headerHeight = document.querySelector('header')?.offsetHeight || 0;
                            window.scrollTo({
                              top: productTable.offsetTop - headerHeight - 10,
                              behavior: 'smooth',
                            });
                          }
                        }}
                      >
                        Back
                      </button>
                      <button
                        style={{
                          ...styles.proceedButton,
                          opacity: amountBelowMinimum ? 0.6 : 1,
                          cursor: amountBelowMinimum ? 'not-allowed' : 'pointer'
                        }}
                        onClick={handleProceedClick}
                        disabled={amountBelowMinimum}
                      >
                        {showDetailsForm ? 'NEXT' : 'NEXT'}
                      </button>
                    </div>
                  </div>
                </div>

              </div>

              {/* Order Details Form */}
              {showDetailsForm && (
                <div style={styles.card} id="orderDetailsForm" ref={formRef}>
                  <div style={styles.formContainer}>
                    <div style={styles.cardHeader}>
                      <h2 style={styles.cardTitle}>Fill Your Details</h2>
                    </div>
                    <form onSubmit={handleSubmit}>
                      <div style={styles.formBody}>
                        <div style={styles.formDetailsColumns}>
                          {/* Left Column - Personal Information */}
                          <div style={styles.formColumn}>
                            <div style={styles.sectionTitle}>
                              <span>📋 Personal Information</span>
                            </div>
                            <div style={{ ...styles.sectionContent, ...styles.sectionContentOpen }}>
                              {/* Name Fields */}
                              <div style={styles.formRow}>
                                <div style={styles.formGroup}>
                                  <label style={styles.formLabel}>First Name<span style={styles.requiredField}>*</span></label>
                                  <input
                                    type="text"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    style={styles.formInput}
                                    placeholder='Enter your first name'
                                    required
                                  />
                                </div>
                                <div style={styles.formGroup}>
                                  <label style={styles.formLabel}>Last Name</label>
                                  <input
                                    type="text"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    style={styles.formInput}
                                    placeholder='Enter your last name'
                                  />
                                </div>
                              </div>

                              {/* Contact and WhatsApp Row for Desktop / Separate for Mobile */}
                              {isMobile ? (
                                // Mobile: Contact Number, then Checkbox, then WhatsApp, then Email
                                <>
                                  <div style={styles.formRow}>
                                    <div style={styles.formGroup}>
                                      <label style={styles.formLabel}>
                                        Contact Number<span style={styles.requiredField}>*</span>
                                      </label>
                                      <input
                                        type="text"
                                        name="contactNumber"
                                        value={formData.contactNumber}
                                        onChange={handleChange}
                                        style={styles.formInput}
                                        placeholder="Enter 10-digit mobile number"
                                        maxLength="10"
                                        required
                                      />
                                    </div>
                                  </div>

                                  <div style={styles.formRow}>
                                    <div style={styles.formGroup}>
                                      <div style={styles.checkboxContainer}>
                                        <input
                                          type="checkbox"
                                          name="sameAsContact"
                                          checked={formData.sameAsContact}
                                          onChange={handleChange}
                                          style={styles.formCheckbox}
                                        />
                                        <label style={{ fontSize: isMobile ? '0.85rem' : '0.8rem', color: '#64748b' }}>
                                          Same as Contact Number
                                        </label>
                                      </div>
                                    </div>
                                  </div>

                                  <div style={styles.formRow}>
                                    <div style={styles.formGroup}>
                                      <label style={styles.formLabel}>
                                        WhatsApp Number<span style={styles.requiredField}>*</span>
                                      </label>
                                      <input
                                        type="text"
                                        name="whatsappNumber"
                                        value={formData.whatsappNumber}
                                        onChange={handleChange}
                                        style={{
                                          ...styles.formInput,
                                          backgroundColor: formData.sameAsContact ? '#f0f0f0' : 'white',
                                          cursor: formData.sameAsContact ? 'not-allowed' : 'text'
                                        }}
                                        placeholder={formData.sameAsContact ? "Same as Contact Number" : "Enter 10-digit WhatsApp number"}
                                        maxLength="10"
                                        required
                                        disabled={formData.sameAsContact}
                                      />
                                    </div>
                                  </div>

                                  <div style={styles.formRow}>
                                    <div style={styles.formGroup}>
                                      <label style={styles.formLabel}>Email Address</label>
                                      <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        style={styles.formInput}
                                        placeholder='Enter your email address'
                                      />
                                    </div>
                                  </div>
                                </>
                              ) : (
                                // Desktop: Contact and WhatsApp in same row, Email and Checkbox in second row
                                <>
                                  <div style={styles.formRow}>
                                    <div style={styles.formGroup}>
                                      <label style={styles.formLabel}>
                                        Contact Number<span style={styles.requiredField}>*</span>
                                      </label>
                                      <input
                                        type="text"
                                        name="contactNumber"
                                        value={formData.contactNumber}
                                        onChange={handleChange}
                                        style={styles.formInput}
                                        placeholder="Enter 10-digit mobile number"
                                        maxLength="10"
                                        required
                                      />
                                    </div>

                                    <div style={styles.formGroup}>
                                      <label style={styles.formLabel}>
                                        WhatsApp Number<span style={styles.requiredField}>*</span>
                                      </label>
                                      <input
                                        type="text"
                                        name="whatsappNumber"
                                        value={formData.whatsappNumber}
                                        onChange={handleChange}
                                        style={{
                                          ...styles.formInput,
                                          backgroundColor: formData.sameAsContact ? '#f0f0f0' : 'white',
                                          cursor: formData.sameAsContact ? 'not-allowed' : 'text'
                                        }}
                                        placeholder={formData.sameAsContact ? "Same as Contact Number" : "Enter 10-digit WhatsApp number"}
                                        maxLength="10"
                                        required
                                        disabled={formData.sameAsContact}
                                      />
                                      {/* Checkbox directly below WhatsApp field in desktop */}
                                      <div style={{ ...styles.checkboxContainer, marginTop: '0.25rem' }}>
                                        <input
                                          type="checkbox"
                                          name="sameAsContact"
                                          checked={formData.sameAsContact}
                                          onChange={handleChange}
                                          style={styles.formCheckbox}
                                        />
                                        <label style={{ fontSize: '0.8rem', color: '#64748b' }}>
                                          Same as Contact Number
                                        </label>
                                      </div>
                                    </div>
                                  </div>

                                  <div style={{ ...styles.formRow, marginTop: '0.5rem' }}>
                                    <div style={styles.formGroup}>
                                      <label style={styles.formLabel}>Email Address</label>
                                      <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        style={styles.formInput}
                                        placeholder='Enter your email address'
                                      />
                                    </div>

                                    {/* Empty div to maintain two-column layout */}
                                    <div style={styles.formGroup}></div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>

                          {/* Right Column - Address Information */}
                          <div style={styles.formColumn}>
                            <div style={styles.sectionTitle}>
                              <span>🏠 Address Information</span>
                            </div>
                            <div style={{ ...styles.sectionContent, ...styles.sectionContentOpen }}>
                              <div style={styles.formRow}>
                                <div style={styles.formGroup}>
                                  <label style={styles.formLabel}>House/Flat No., Building Name, Area<span style={styles.requiredField}>*</span></label>
                                  <input
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                    style={styles.formInput}
                                    placeholder="Enter your (House/Flat No., Building Name, Area)"
                                    required
                                  />
                                </div>
                                <div style={styles.formGroup}>
                                  <label style={styles.formLabel}>City<span style={styles.requiredField}>*</span></label>
                                  <input
                                    type="text"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                    style={styles.formInput}
                                    placeholder="City"
                                    required
                                  />
                                </div>
                              </div>

                              <div style={styles.formRow}>
                                <div style={styles.formGroup}>
                                  <label style={styles.formLabel}>District<span style={styles.requiredField}>*</span></label>
                                  <input
                                    type="text"
                                    name="district"
                                    value={formData.district}
                                    onChange={handleChange}
                                    style={styles.formInput}
                                    placeholder="Enter district"
                                    required
                                  />
                                </div>
                                <div style={styles.formGroup}>
                                  <label style={styles.formLabel}>State<span style={styles.requiredField}>*</span></label>
                                  <input
                                    type="text"
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                    style={styles.formInput}
                                    placeholder="State"
                                    required
                                  />
                                </div>
                              </div>
                              <div style={styles.formRow}>
                                <div style={styles.formGroup}>
                                  <label style={styles.formLabel}>PIN Code<span style={styles.requiredField}>*</span></label>
                                  <input
                                    type="text"
                                    name="pinCode"
                                    value={formData.pinCode}
                                    onChange={handleChange}
                                    style={styles.formInput}
                                    placeholder="PIN Code"
                                    maxLength="10"
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Submit Section */}
                      <div style={styles.submitSection}>
                        <div style={styles.termsSection}>
                          <input
                            type="checkbox"
                            id="agreeToTerms"
                            name="agreeToTerms"
                            required
                            style={{
                              ...styles.formCheckbox,
                              accentColor: '#1a237e'
                            }}
                          />
                          <label htmlFor="agreeToTerms" style={{ fontSize: isMobile ? '0.9rem' : '0.85rem', color: '#64748b' }}>
                            I have read and agree to the{' '}
                            <span
                              style={{
                                color: '#1a237e',
                                textDecoration: 'underline',
                                cursor: 'pointer'
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                setShowTermsPopup(true);
                              }}
                            >
                              Terms and Conditions
                            </span>
                            <span style={styles.requiredField}> *</span>
                          </label>
                        </div>

                        <div style={styles.actionButtons}>
                          <button
                            type="submit"
                            style={{
                              ...styles.confirmButton,
                              backgroundColor: isProcessing ? '#4CAF50' : 'green',
                              cursor: isProcessing ? 'wait' : 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                            disabled={isProcessing}
                          >
                            {isProcessing ? (
                              <>
                                <span style={{
                                  display: 'inline-block',
                                  width: '16px',
                                  height: '16px',
                                  border: '2px solid rgba(255,255,255,0.3)',
                                  borderRadius: '50%',
                                  borderTopColor: '#fff',
                                  animation: 'spin 1s ease-in-out infinite',
                                  marginRight: '8px'
                                }} />
                                PROCESSING...
                              </>
                            ) : (
                              'CONFIRM ORDER'
                            )}
                          </button>
                          <button
                            type="button"
                            style={styles.cancelButton}
                            onClick={() => setShowCancelPopup(true)}
                          >
                            CANCEL
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              )}
            </div>
          </div>

        )}
        <Footer />


        {showCancelPopup && <CancelConfirmationPopup />}
        {showTermsPopup && <TermsPopup />}
      </>
    );
  }

  export default QuickPurchase; 
